import { render, staticRenderFns } from "./Distribute.vue?vue&type=template&id=49d20060&scoped=true&"
import script from "./Distribute.vue?vue&type=script&lang=js&"
export * from "./Distribute.vue?vue&type=script&lang=js&"
import style0 from "./Distribute.vue?vue&type=style&index=0&id=49d20060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d20060",
  null
  
)

export default component.exports